<template>
  <va-create-layout>
    <country-form :title="title" :item="item"></country-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ["title", "item"],
};
</script>
